import React from 'react';
import { Link } from 'react-router-dom';
import './TermsConditions.css';

function TermsConditions({ onBack }) {
  return (
    <div className="terms-container">
      {onBack ? (
        <button className="back-button" onClick={onBack}>← Back to Home</button>
      ) : (
        <Link to="/" className="back-button" style={{textDecoration: 'none', display: 'inline-block'}}>← Back to Home</Link>
      )}
      
      <div className="terms-content">
        <div className="terms-header">
          <h1>TERMS & CONDITIONS – AUCTION MODEL</h1>
          <p className="company-name">Vahaan Bazar Private Limited</p>
          <p className="effective-date">(Effective as of 07-11-2025)</p>
        </div>

        <section className="terms-section">
          <h2>1. Introduction</h2>
          <p>These Terms & Conditions ("T&C") govern the participation of customers ("Bidder/Participant/You") in the auctions conducted by Vahaan Bazar Private Limited, a company incorporated under the Companies Act, 2013, having its registered office at No 408, Babukhan Estates, Basheerbagh, Hyderabad-500001 ("Vahaan Bazar/Company").</p>
          <p>By participating in the auction and paying the Earnest Money Deposit ("EMD"), you agree to be bound by these T&C.</p>
        </section>

        <section className="terms-section">
          <h2>2. EMD Refund Policy</h2>
          <ul>
            <li>EMD will be refunded to all non-winning bidders with no active bids.</li>
            <li>Refunds will be processed within 7–10 working days from the refund request date.</li>
            <li>Refunds will be made only to the same account/payment method used while paying the EMD.</li>
            <li>No interest is payable on the EMD amount.</li>
            <li>Refund timelines may vary in case of technical delays by banks/payment gateways.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>3. Earnest Money Deposit (EMD)</h2>
          <ul>
            <li>Participation in any auction requires payment of a refundable EMD, the amount of which will be specified for each auction.</li>
            <li>EMD must be paid before bidding access is granted.</li>
            <li>EMD is fully refundable to bidders who:
              <ul>
                <li>Do not win the auction, OR</li>
                <li>Withdraw before placing any active bid.</li>
              </ul>
            </li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>4. EMD Forfeiture Conditions</h2>
          <p>The EMD may be forfeited, fully or partially, in the following situations:</p>
          <ul>
            <li>If the Bidder wins the auction but fails to:
              <ul>
                <li>Pay the winning bid amount within the stipulated time, or</li>
                <li>Complete documentation and verification required for delivery.</li>
              </ul>
            </li>
            <li>If the Bidder places false bids, uses fraudulent information, or violates any auction rule.</li>
            <li>If the Bidder withdraws after placing an active bid without a valid reason accepted by Vahaan Bazar.</li>
            <li>If the auction rules of a specific vehicle/equipment state additional forfeiture terms.</li>
          </ul>
          <p className="highlight-text">Vahaan Bazar's decision on forfeiture shall be final and binding.</p>
        </section>

        <section className="terms-section">
          <h2>5. Eligibility</h2>
          <ul>
            <li>Bidders must be 18 years or above, legally competent to enter into a contract under the Indian Contract Act, 1872.</li>
            <li>Participants must provide valid KYC documents as required by Vahaan Bazar (Aadhaar, PAN, mobile number, etc.).</li>
            <li>The Company reserves the right to accept or reject any registration without assigning reasons.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>6. Bidding Rules</h2>
          <ul>
            <li>All bids placed are legally binding offers under Indian Contract Law.</li>
            <li>Bidders must inspect the vehicle/equipment (physically or through provided reports) before bidding.</li>
            <li>Vahaan Bazar does not guarantee:
              <ul>
                <li>Vehicle condition,</li>
                <li>Year of manufacture,</li>
                <li>Odometer reading,</li>
                <li>Ownership history,</li>
              </ul>
              unless specifically mentioned.
            </li>
            <li>Bids once placed cannot be reversed.</li>
            <li>The highest bidder at auction close will be declared the winner, subject to verification.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>7. Payment & Delivery</h2>
          <ul>
            <li>Winning bidders must pay the remaining amount within 48–72 hours of auction close (or timeline specified in listing).</li>
            <li>Failure to make payment will result in EMD forfeiture.</li>
            <li>Delivery/handover of the asset will occur only after:
              <ul>
                <li>Full payment,</li>
                <li>Document verification,</li>
                <li>Completion of RTO/legal requirements (where applicable).</li>
              </ul>
            </li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>8. Cancellation of Auction</h2>
          <p>Vahaan Bazar may cancel, postpone, or modify an auction at any time due to technical issues, seller withdrawal, legal reasons, or other unavoidable circumstances.</p>
          <p>In such cases, EMD will be fully refunded.</p>
        </section>

        <section className="terms-section">
          <h2>9. Limitation of Liability</h2>
          <ul>
            <li>Vahaan Bazar acts only as a facilitator between buyers and sellers.</li>
            <li>The Company shall not be liable for:
              <ul>
                <li>Any disputes between buyer and seller,</li>
                <li>Vehicle defects not disclosed by the seller,</li>
                <li>Delays caused by third parties (RTO, transport, banks, etc.).</li>
              </ul>
            </li>
            <li>Maximum liability is limited to the EMD amount paid by the participant.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>10. Compliance & Legal Framework</h2>
          <ul>
            <li>These T&C are governed by the laws of India.</li>
            <li>Any disputes shall be subject to exclusive jurisdiction of courts in Hyderabad, Telangana.</li>
            <li>Participants must strictly comply with:
              <ul>
                <li>The Information Technology Act, 2000,</li>
                <li>Consumer Protection Act, 2019,</li>
                <li>Indian Contract Act, 1872,</li>
                <li>Any applicable motor vehicle/RTO laws.</li>
              </ul>
            </li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>11. Data & Privacy</h2>
          <ul>
            <li>Participant information will be used as per Vahaan Bazar's Privacy Policy.</li>
            <li>Data may be shared with sellers, partners, or authorities only as required for auction purposes.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>12. Amendments</h2>
          <p>Vahaan Bazar reserves the right to modify these T&C at any time. Updated terms will be made available on the website/app.</p>
        </section>
      </div>
    </div>
  );
}

export default TermsConditions;
